export const GET_COMPANY_SETTINGS_QUERY_KEY = ['company_settings'] as const;
